<template>

  <div class="content-block dx-card">
    <h2>Sites</h2> <!-- ❯ = unicode U+276F  -->
  </div>

  <div class="content-block dx-card" id="dataDiv">
    <DxDataGrid
      class="dx-card wide-card"
      :data-source="sites"
      :key-expr="containerId"
      :hover-state-enabled="true"
      :selection="{ mode: 'single' }"
      :show-borders="true"
      :columns-auto-width="true"
      :column-min-width="50"
      :allow-column-resizing="true"
      column-resizing-mode="widget"
      :allow-column-reordering="true"
      :filter-builder="filterBuilder"
      :filter-value="filterValue"
      :style="{ 'max-height': datagridHeight }"
      no-data-text="No data."    
      @initialized="saveGridInstance"
    >
      <!-- @selection-changed="onSelectionChanged" -->
      <!-- <DxLoadPanel :enabled="true" /> -->
      <DxStateStoring :enabled="true" type="localStorage" storage-key="system-sites-grid" />
      <DxColumnChooser :enabled="true" mode="select" />
      <DxFilterRow :visible="true" />
      <DxHeaderFilter :visible="true" />
      <DxScrolling mode="standard" />
      <DxExport :enabled="true" />
      <DxColumnFixing :enabled="true" />
      <DxPager
        :show-info="true"
        :show-page-size-selector="true"
        :allowed-page-sizes="[20, 50, 100]"
        :show-navigation-buttons="true"
      />

      <DxToolbar>
        <!-- <DxItem location="before" template="addRecordTemplate" /> -->
        <DxItem location="after" template="refreshRecordTemplate" />
        <DxItem location="after" template="removeFilterRecordTemplate" />
        <DxItem location="after" name="exportButton" />
        <DxItem location="after" name="columnChooserButton" />
      </DxToolbar>

      <!-- <template #addRecordTemplate>
        <DxButton icon="add" @click="newRec" />
      </template> -->
      <template #refreshRecordTemplate>
        <DxButton icon="refresh" @click="refreshData" />
      </template>
      <template #removeFilterRecordTemplate>
        <DxButton icon="filter" @click="removeFilter" />
      </template>

      <!-- <DxColumn data-field="routeName" caption="Route" />
      <DxColumn data-field="operators" caption="Operators" />
      <DxColumn data-field="areas" caption="Areas" />
      <DxColumn data-field="products" caption="Products" />
      <DxColumn data-field="numberOfSites" caption="Number of Sites" />
      <DxColumn
        data-field="createdAt"
        caption="Date Created"
        data-type="date"
        :format="{ type: 'datetime', displayFormat: 'MMM d, yyyy h:mm a' }"
        :customize-text="createdDateText"
      /> -->
    </DxDataGrid>
  </div>

  <DxLoadPanel
    v-model:visible="loadingVisible"
    :message="Loading"
    :show-indicator="true"
    :show-pane="true"
    :shading="true"
    :hide-on-outside-click="false"
    :on-shown="onLoadPanelShown"
    :on-hidden="onLoadPanelHidden"
    shading-color="rgba(0,0,0,0.4)"
  />
</template>

<script>

import {
  DxDataGrid,
  DxHeaderFilter,
  DxFilterRow,
  DxScrolling,
  DxColumnChooser,
  DxColumnFixing,
  DxPager,
  DxItem,
  DxToolbar,
  DxExport,
  DxStateStoring,
} from "devextreme-vue/data-grid";
import { DxButton } from "devextreme-vue/button";
import { DxLoadPanel } from "devextreme-vue/load-panel";

export default {
  components: {
    DxDataGrid,
    // DxColumn,
    DxHeaderFilter,
    DxFilterRow,
    DxScrolling,
    DxColumnChooser,
    DxLoadPanel,
    DxButton,
    DxToolbar,
    DxItem,
    DxExport,
    DxColumnFixing,
    DxPager,
    DxStateStoring
  },
  data() {
    return {
      // columnResize: "widget",
      dataGridInstance: null,
      loadingVisible: false,
      isLoadPanelVisible: false,
      datagridHeight: "40vh",
      currentArea: null,
      routes: [],
    };
  },
  created() {
    this.loadPageData();
  },
  mounted() {
    window.addEventListener('resize', this.setDimensions);
    this.setDimensions();
  },
  unmounted() {
    window.removeEventListener('resize', this.setDimensions);
  },  
  computed: {
    sites() {
      return this.$store.getters["siteList/getSystemSites"]
    },
  },
  methods: {
    onLoadPanelShown() {
      setTimeout(() => {
        this.loadingVisible = false;
      }, 10000);
    },
    onLoadPanelHidden() {},
    setDimensions() {
      const h = document.documentElement.clientHeight;
      this.datagridHeight = (h - 250) + 'px';
    },
    async loadPageData(refresh = false) {
      this.loadingVisible = true;
      try {
        await this.$store.dispatch("siteList/loadAllSites", 1);        
      } catch (error) {
        this.error = error.message || "Unexpected Error.";
      }
      this.loadingVisible = false;
    },
  }
};
</script>

<style scoped>
h2 {
  margin-left: 1em;
}
</style>
